import SearchPage from './SearchPage'
import SearchPageDr from './SearchPageDr'
import SearchPageGroup from './SearchPageGroup'

export {
  SearchPage,
  SearchPageDr,
  SearchPageGroup,
}
